import { render, staticRenderFns } from "./clientsManualToolsStatistics.vue?vue&type=template&id=0fd793fa"
import script from "./clientsManualToolsStatistics.vue?vue&type=script&lang=js"
export * from "./clientsManualToolsStatistics.vue?vue&type=script&lang=js"
import style0 from "./clientsManualToolsStatistics.vue?vue&type=style&index=0&id=0fd793fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports